/*
  This example requires some changes to your config:

  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ],
  }
  ```
*/
import React, {Fragment, useEffect} from 'react'
import {CreditCardIcon, XCircleIcon, XMarkIcon,} from '@heroicons/react/20/solid'
import {useLocation, useNavigate} from "react-router-dom";
import {getVenueSession} from "../../requests/AppSession";
import {NumericFormat} from "react-number-format";
import dateFormat from "dateformat";
import {Skeleton} from "@mui/material";
import {Transition} from "@headlessui/react";
import {useAuth0} from "@auth0/auth0-react";
import {createInvoicePaymentUrl} from "../requests/AppRequestStripeInvoicePayment";
import {findVenueInvoiceDetail} from "../requests/AppRequestVenueInvoice";
import {TableRowsSkeleton} from "./VTSkeletons";

export default function VTVenueInvoiceDetails() {
    let navigate = useNavigate();
    const {state} = useLocation();

    const {isLoading, getAccessTokenSilently} = useAuth0();

    const [venueId, setVenueId] = React.useState(null);
    const [venueName, setVenueName] = React.useState(null);
    const [venueInvoice, setVenueInvoice] = React.useState(null);

    const [errorMessage, setErrorMessage] = React.useState(null);
    const [showError, setShowError] = React.useState(false);
    const [isSubmitting, setIsSubmitting] = React.useState(false);

    const createPaymentUrlSuccess = (responseJson) => {
        setIsSubmitting(false);
        if (responseJson && responseJson.paymentUrl) {
            window.location.replace(responseJson.paymentUrl);
        }
    };

    const createPaymentUrlError = () => {
        setIsSubmitting(false);
        setShowError(true);
    };
    useEffect(() => {
        getVenueSession().then(venueSession => {
            if (venueSession && venueSession.id !== "null") {
                setVenueId(venueSession.venueId);
                setVenueName(venueSession.venueName);
            } else {
                navigate('/login/mobile', {replace: true});
            }
        })
        return function cleanup() {

        };
    }, []);

    const getSuccess = async responseJson => {
        if (
            responseJson
        ) {
            setVenueInvoice(responseJson);
        } else {
            setErrorMessage("Error accessing venue invoice, please refresh and verify Internet Connection.");
        }
    };

    const getError = forceLogout => {
        setErrorMessage("Error accessing venue invoice, please refresh and verify Internet Connection.");
    };

    useEffect(() => {
        const invoiceId = state && state.invoiceId;

        if (venueId) {
            if (invoiceId) {
                findVenueInvoiceDetail(venueId, invoiceId, getSuccess, getError, getAccessTokenSilently);
            } else {
                navigate('/login/mobile', {replace: true});
            }
        }

        return function cleanup() {

        };
    }, [isLoading, venueId]);

    return (
        <>
            <main>
                <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
                    <div
                        className="mx-auto grid max-w-2xl grid-cols-1 grid-rows-1 items-start gap-x-8 gap-y-8 lg:mx-0 lg:max-w-none lg:grid-cols-3">
                        {/* Invoice summary */}
                        <div className="lg:col-start-3 lg:row-end-1">
                            <h2 className="sr-only">Summary</h2>
                            <div className="rounded-lg bg-gray-50 dark:bg-gray-800 shadow-sm ring-1 ring-gray-900/5">
                                <dl className="flex flex-wrap">
                                    <div className="flex-auto pl-6 pt-6">
                                        <dt className="text-sm font-semibold leading-6 text-gray-900 dark:text-gray-100">Amount Owed</dt>
                                        <dd className="mt-1 text-base font-semibold leading-6 text-gray-900 dark:text-gray-100">
                                            {venueInvoice ? <NumericFormat
                                                    value={venueInvoice ? venueInvoice.totalAmount : 0}
                                                    displayType={'text'}
                                                    decimalScale={2}
                                                    fixedDecimalScale={true}
                                                    thousandSeparator={true}
                                                    prefix={'$'}/>
                                                :
                                                <Skeleton variant="rounded"/>}
                                        </dd>
                                    </div>
                                    <div className="flex-none self-end px-6 pt-4">
                                        <dt className="sr-only">Status</dt>
                                        {/*<dd className="rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-600 ring-1 ring-inset ring-green-600/20">*/}
                                        {/*    Paid*/}
                                        {/*</dd>*/}
                                        {venueInvoice && venueInvoice.paid ? <div
                                                className={'text-green-700 bg-green-50 ring-green-600/20 rounded-md py-1 px-2 text-xs font-medium ring-1 ring-inset'}
                                            >
                                                Paid
                                            </div> :
                                            <div
                                                className={'text-red-700 bg-red-50 ring-red-600/10 rounded-md py-1 px-2 text-xs font-medium ring-1 ring-inset'}
                                            >
                                                Due
                                            </div>
                                        }
                                    </div>
                                </dl>
                                <div className="mt-6 border-t border-gray-900/5 px-6 py-6">
                                    {/*<button className="text-xl font-medium leading-6 text-gray-900 ring-1 ring-inset">*/}
                                    {/*    Pay <span aria-hidden="true">&rarr;</span>*/}
                                    {/*</button>*/}
                                    <button
                                        type="button"
                                        disabled={isSubmitting}
                                        className="inline-flex items-center gap-x-1.5 rounded-md bg-green-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
                                        onClick={() => {
                                            setIsSubmitting(true);
                                            createInvoicePaymentUrl(venueId, venueInvoice.id, createPaymentUrlSuccess, createPaymentUrlError, getAccessTokenSilently);
                                        }}
                                    >
                                        Pay Invoice
                                        <CreditCardIcon className="-mr-0.5 h-5 w-5" aria-hidden="true"/>
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Invoice */}
                        <div
                            className="-mx-4 px-4 py-8 shadow-sm ring-1 ring-gray-900/5 sm:mx-0 sm:rounded-lg sm:px-8 sm:pb-14 lg:col-span-2 lg:row-span-2 lg:row-end-2 xl:px-16 xl:pb-20 xl:pt-16">
                            <h2 className="text-base font-semibold leading-6 text-gray-900 dark:text-gray-100">Invoice</h2>
                            <dl className="mt-6 grid grid-cols-1 text-sm leading-6 sm:grid-cols-2">
                                <div className="sm:pr-4">
                                    <dt className="inline text-gray-500 dark:text-gray-400">Issued on</dt>
                                    {' '}
                                    <dd className="inline text-gray-700 dark:text-gray-200">
                                        {dateFormat(venueInvoice && venueInvoice.createDate, "mmmm dS, yyyy")}
                                    </dd>
                                </div>
                                <div className="mt-2 sm:mt-0 sm:pl-4">
                                    <dt className="inline text-gray-500 dark:text-gray-400">Due By</dt>
                                    {' '}
                                    <dd className="inline text-gray-700 dark:text-gray-200">
                                        {dateFormat(venueInvoice && venueInvoice.payBy, "mmmm dS, yyyy")}
                                    </dd>
                                </div>
                                {/*<div className="mt-6 border-t border-gray-900/5 pt-6 sm:pr-4">*/}
                                {/*    <dt className="font-semibold text-gray-900">Venue Profit</dt>*/}
                                {/*    <dd className="mt-2 text-gray-500">*/}
                                {/*        <span className="font-medium text-gray-900">*/}
                                {/*            {venueInvoice && <NumericFormat value={venueInvoice.profit}*/}
                                {/*                                            displayType={'text'}*/}
                                {/*                                            decimalScale={2}*/}
                                {/*                                            fixedDecimalScale={true}*/}
                                {/*                                            thousandSeparator={true}*/}
                                {/*                                            prefix={'$'}/>}*/}
                                {/*        </span>*/}
                                {/*        /!*<br/>*!/*/}
                                {/*        /!*7363 Cynthia Pass*!/*/}
                                {/*        /!*<br/>*!/*/}
                                {/*        /!*Toronto, ON N3Y 4H8*!/*/}
                                {/*    </dd>*/}
                                {/*</div>*/}
                                <div className="mt-6 border-t border-gray-900/5 pt-6 sm:pr-4">
                                    <dt className="font-semibold text-gray-900 dark:text-gray-100">Total Gross Amount</dt>
                                    <dd className="mt-2 text-gray-500 dark:text-gray-400">
                                        <span className="font-medium text-gray-900 dark:text-gray-100">
                                        {venueInvoice && <NumericFormat value={venueInvoice.totalGrossAmount}
                                                                        displayType={'text'}
                                                                        decimalScale={2}
                                                                        fixedDecimalScale={true}
                                                                        thousandSeparator={true}
                                                                        prefix={'$'}/>}
                                        </span>
                                        {/*<br/>*/}
                                        {/*7363 Cynthia Pass*/}
                                        {/*<br/>*/}
                                        {/*Toronto, ON N3Y 4H8*/}
                                    </dd>
                                </div>
                                {/*<div className="mt-8 sm:mt-6 sm:border-t sm:border-gray-900/5 sm:pl-4 sm:pt-6">*/}
                                {/*    <dt className="font-semibold text-gray-900">Total VirtualTipz</dt>*/}
                                {/*    <dd className="mt-2 text-gray-500">*/}
                                {/*        <span className="font-medium text-gray-900">*/}
                                {/*       {venueInvoice && <NumericFormat value={venueInvoice.tipMoney}*/}
                                {/*                                       displayType={'text'}*/}
                                {/*                                       // decimalScale={2}*/}
                                {/*                                       fixedDecimalScale={true}*/}
                                {/*                                       thousandSeparator={true}*/}
                                {/*                                       suffix={' VT '}*/}
                                {/*                                       prefix={''}/>}*/}
                                {/*        </span>*/}
                                {/*        /!*<br/>*!/*/}
                                {/*        /!*886 Walter Street*!/*/}
                                {/*        /!*<br/>*!/*/}
                                {/*        /!*New York, NY 12345*!/*/}
                                {/*    </dd>*/}
                                {/*</div>*/}
                                {/*<div className="mt-6 border-t border-gray-900/5 pt-6 sm:pr-4">*/}
                                {/*    <dt className="font-semibold text-gray-900">Total Gross Amount</dt>*/}
                                {/*    <dd className="mt-2 text-gray-500">*/}
                                {/*        <span className="font-medium text-gray-900">*/}
                                {/*        {venueInvoice && <NumericFormat value={venueInvoice.totalGrossAmount}*/}
                                {/*                                        displayType={'text'}*/}
                                {/*                                        decimalScale={2}*/}
                                {/*                                        fixedDecimalScale={true}*/}
                                {/*                                        thousandSeparator={true}*/}
                                {/*                                        prefix={'$'}/>}*/}
                                {/*        </span>*/}
                                {/*        /!*<br/>*!/*/}
                                {/*        /!*7363 Cynthia Pass*!/*/}
                                {/*        /!*<br/>*!/*/}
                                {/*        /!*Toronto, ON N3Y 4H8*!/*/}
                                {/*    </dd>*/}
                                {/*</div>*/}
                                <div className="mt-8 sm:mt-6 sm:border-t sm:border-gray-900/5 sm:pl-4 sm:pt-6">
                                    {/*<dt className="font-semibold text-gray-900">To</dt>*/}
                                    {/*<dd className="mt-2 text-gray-500">*/}
                                    {/*    <span className="font-medium text-gray-900">Tuple, Inc</span>*/}
                                    {/*    <br/>*/}
                                    {/*    886 Walter Street*/}
                                    {/*    <br/>*/}
                                    {/*    New York, NY 12345*/}
                                    {/*</dd>*/}
                                </div>
                            </dl>
                            <table className="mt-16 w-full whitespace-nowrap text-left text-sm leading-6">
                                <colgroup>
                                    <col className="w-full"/>
                                    <col/>
                                    <col/>
                                    <col/>
                                </colgroup>
                                <thead className="border-b border-gray-200 dark:border-gray-700 text-gray-900 dark:text-gray-100">
                                <tr>
                                    <th scope="col" className="px-0 py-3 font-semibold">
                                        Package Name
                                    </th>
                                    <th scope="col"
                                        className="hidden py-3 pl-8 pr-0 text-right font-semibold sm:table-cell">
                                        Date
                                    </th>
                                    <th scope="col"
                                        className="hidden py-3 pl-8 pr-0 text-right font-semibold sm:table-cell">
                                        Price
                                    </th>
                                    <th scope="col" className="py-3 pl-8 pr-0 text-right font-semibold">
                                        Owe
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                {!venueInvoice && <TableRowsSkeleton rows={4} cols={2}/>}

                                {venueInvoice && venueInvoice.purchaseVTVenueDtoList.map((item) => (
                                    <tr key={item.id} className="border-b border-gray-100 dark:border-gray-700">
                                        <td className="max-w-0 px-0 py-5 align-top">
                                            <div className="truncate font-medium text-gray-900 dark:text-gray-100">{item.packageName}</div>
                                            {/*<div className="truncate text-gray-500">{item.description}</div>*/}
                                        </td>
                                        <td className="hidden py-5 pl-8 pr-0 text-right align-top tabular-nums text-gray-700 dark:text-gray-200 sm:table-cell">
                                            {dateFormat(item.purchaseDate, "mmmm dS, yyyy")}
                                        </td>
                                        <td className="hidden py-5 pl-8 pr-0 text-right align-top tabular-nums text-gray-700 dark:text-gray-200 sm:table-cell">
                                            <NumericFormat
                                                value={item.price} displayType={'text'}
                                                decimalScale={2} fixedDecimalScale={true}
                                                thousandSeparator={true} prefix={'$'}/>
                                        </td>
                                        <td className="py-5 pl-8 pr-0 text-right align-top tabular-nums text-gray-700 dark:text-gray-200">
                                            <NumericFormat
                                                value={item.amountToApp} displayType={'text'}
                                                decimalScale={2} fixedDecimalScale={true}
                                                thousandSeparator={true} prefix={'$'}/>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                                <tfoot>
                                {/*<tr>*/}
                                {/*    <th scope="row" className="px-0 pb-0 pt-6 font-normal text-gray-700 sm:hidden">*/}
                                {/*        Subtotal*/}
                                {/*    </th>*/}
                                {/*    <th*/}
                                {/*        scope="row"*/}
                                {/*        colSpan={3}*/}
                                {/*        className="hidden px-0 pb-0 pt-6 text-right font-normal text-gray-700 sm:table-cell"*/}
                                {/*    >*/}
                                {/*        Subtotal*/}
                                {/*    </th>*/}
                                {/*    <td className="pb-0 pl-8 pr-0 pt-6 text-right tabular-nums text-gray-900">{invoice.subTotal}</td>*/}
                                {/*</tr>*/}
                                {/*<tr>*/}
                                {/*    <th scope="row" className="pt-4 font-normal text-gray-700 sm:hidden">*/}
                                {/*        Tax*/}
                                {/*    </th>*/}
                                {/*    <th*/}
                                {/*        scope="row"*/}
                                {/*        colSpan={3}*/}
                                {/*        className="hidden pt-4 text-right font-normal text-gray-700 sm:table-cell"*/}
                                {/*    >*/}
                                {/*        Tax*/}
                                {/*    </th>*/}
                                {/*    <td className="pb-0 pl-8 pr-0 pt-4 text-right tabular-nums text-gray-900">{invoice.tax}</td>*/}
                                {/*</tr>*/}
                                {venueInvoice && <tr>
                                    <th scope="row" className="pt-4 font-semibold text-gray-900 dark:text-gray-100 sm:hidden">
                                        Total
                                    </th>
                                    <th
                                        scope="row"
                                        colSpan={3}
                                        className="hidden pt-4 text-right font-semibold text-gray-900 dark:text-gray-100 sm:table-cell"
                                    >
                                        Total
                                    </th>
                                    <td className="pb-0 pl-8 pr-0 pt-4 text-right font-semibold tabular-nums text-gray-900 dark:text-gray-100">
                                        {venueInvoice && <NumericFormat
                                            value={venueInvoice ? venueInvoice.totalAmount : 0}
                                            displayType={'text'}
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                            thousandSeparator={true}
                                            prefix={'$'}/>}
                                    </td>
                                </tr>}
                                </tfoot>
                            </table>
                        </div>

                        <div className="lg:col-start-3">
                        </div>
                    </div>
                </div>
            </main>

            {/* Global notification live region, render this permanently at the end of the document */}
            <div
                aria-live="assertive"
                className="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6"
            >
                <div className="flex w-full flex-col items-center space-y-4 sm:items-end">
                    {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
                    <Transition
                        show={showError}
                        as={Fragment}
                        enter="transform ease-out duration-300 transition"
                        enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                        enterTo="translate-y-0 opacity-100 sm:translate-x-0"
                        leave="transition ease-in duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div
                            className="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white dark:bg-gray-800 shadow-lg ring-1 ring-black ring-opacity-5">
                            <div className="p-4">
                                <div className="flex items-start">
                                    <div className="flex-shrink-0">
                                        <XCircleIcon className="h-6 w-6 text-red-700" aria-hidden="true"/>
                                    </div>
                                    <div className="ml-3 w-0 flex-1 pt-0.5">
                                        <p className="text-sm font-medium text-gray-900 dark:text-gray-100">Paying Invoice failed, please
                                            try again!</p>
                                    </div>
                                    <div className="ml-4 flex flex-shrink-0">
                                        <button
                                            type="button"
                                            className="inline-flex rounded-md bg-white dark:bg-gray-800 text-gray-400 dark:text-gray-500 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-green-700 focus:ring-offset-2"
                                            onClick={() => {
                                                setShowError(false)
                                            }}
                                        >
                                            <span className="sr-only">Close</span>
                                            <XMarkIcon className="h-5 w-5" aria-hidden="true"/>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Transition>
                </div>
            </div>
        </>
    )
}
